var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 67,
    viewBox: "0 0 78 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_791_8446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 32.5507C65 42.5836 59.3185 51.2901 50.9956 55.6261C50.9956 55.6261 24.0785 59.0838 17.4325 38.6585C10.7879 18.2333 35.8938 6.73301 35.8938 6.73301C51.4402 4.87508 65 17.0217 65 32.5507Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9956 55.6261C33.8345 64.5735 12.9962 52.1404 12.9962 32.5507C12.9962 19.2409 22.9959 8.26658 35.8939 6.73303C28.4216 15.295 11.9179 39.8272 50.9956 55.6261Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9421 39.6469C56.0644 44.6569 52.258 48.723 47.4258 50.9396L35.0829 51.3259C31.6703 50.0021 27.6503 47.2573 23.8234 41.7421C21.1869 37.9409 19.8066 33.7338 20.4825 29.1932C21.8307 20.1354 30.4505 14.2306 30.4757 14.2053L38.5542 16.6432L46.2567 13.6681C51.1696 15.5585 55.1589 19.3113 57.3589 24.0616C59.6399 28.9849 59.82 34.6372 57.9421 39.6469Z",
    fill: "url(#paint0_linear_791_8446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6688 51.1199L31.733 51.4308C26.7013 49.4943 22.639 45.6034 20.4773 40.688C20.9204 31.5435 20.9692 35.2747 20.1614 25.1744C22.062 20.3255 25.779 16.3899 30.4757 14.2052C22.0022 28.8689 25.4104 41.6527 41.6688 51.1199Z",
    fill: "#F4BB42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3351 33.675L34.5738 34.454L27.8588 37.4239C19.7176 34.5307 26.0323 27.46 26.0323 27.46L34.5239 30.765L36.3197 31.4647L36.3351 33.675Z",
    fill: "#ED3A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8587 37.4239L20.4773 40.688C18.309 35.762 18.216 30.1334 20.1613 25.1744L26.0322 27.46C25.8212 30.6999 26.3098 34.0677 27.8587 37.4239Z",
    fill: "#CD2407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9422 39.6469L43.5195 34.211L41.7161 33.5318L41.6035 31.3012L57.359 24.0618C59.64 28.9849 59.8201 34.6372 57.9422 39.6469Z",
    fill: "#ED3A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4257 50.9396C46.2311 51.4883 44.9738 51.9245 43.6679 52.2327C34.1991 52.7674 33.9868 45.5611 33.9868 45.5611L37.2574 37.0414L37.9481 35.2418L40.2006 35.1779L41.0038 36.9301L47.4257 50.9396Z",
    fill: "#ED3A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.668 52.2328C39.7717 53.1537 35.5794 52.9129 31.733 51.4308L33.9867 45.5612C36.4874 47.8635 39.6721 50.1044 43.668 52.2328Z",
    fill: "#CD2407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2567 13.6679L40.7146 28.0508L40.0226 29.8479L37.8328 29.9068L37.0564 28.1429L30.4758 14.2051C35.3776 12.0447 41.3319 11.7729 46.2567 13.6679Z",
    fill: "#ED3A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9983 37.3663C41.6577 37.3663 43.8135 35.2104 43.8135 32.551C43.8135 29.8916 41.6577 27.7357 38.9983 27.7357C36.3389 27.7357 34.183 29.8916 34.183 32.551C34.183 35.2104 36.3389 37.3663 38.9983 37.3663Z",
    fill: "#4B1B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4103 3.6593H35.5863C34.5624 3.6593 33.8841 4.76604 34.3145 5.73399L37.7266 13.4064C37.9775 13.9708 38.4879 14.253 38.9983 14.2528C39.5087 14.2528 40.019 13.9707 40.2699 13.4064L43.6819 5.73399C44.1123 4.76604 43.434 3.6593 42.4103 3.6593Z",
    fill: "#F5D016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_791_8446",
    x: 8.99622,
    y: 3.6593,
    width: 60.0038,
    height: 62.9213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_8446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_8446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_791_8446",
    x1: 39.7677,
    y1: 13.6681,
    x2: 39.7677,
    y2: 51.3259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpin);
export default __webpack_public_path__ + "static/media/icon_spin.10a509b4ee30d1df6af51b9e3c9d852e.svg";
export { ForwardRef as ReactComponent };